import { fetchChatList, fetchUnreadNotificationCount } from "./fetch"

export function applyNotificationDots(accessToken: string) {
    applyStarsChatNotificationDot(accessToken)
    applyUserNotificationDot(accessToken)
}

async function applyStarsChatNotificationDot(accessToken: string) {
    const result = await fetchChatList(accessToken)
    const menuElement = document.getElementById("chat_menu_dot")
    const loginMenuChatDot = document.getElementById("notification-login-menu-dot")
    for (let i = 0; i < result.length; i++) {
        const count = result[i].newMessageCount
        if (count > 0) {
            if (menuElement !== null) {
                menuElement.classList.add("profile-modal-navbar-dot")
            }
            if (loginMenuChatDot !== null) {
                loginMenuChatDot.classList.add("notification-dot")
            }
            break
        }
    }
}

async function applyUserNotificationDot(accessToken: string) {
    const result = await fetchUnreadNotificationCount(accessToken)

    if (result.unreadCount > 0) {
        const menuElement = document.getElementById("notification_menu_dot")
        if (menuElement !== null) {
            menuElement.classList.add("profile-modal-navbar-dot")
        }
        const loginMenuNotificationDot = document.getElementById("notification-login-menu-dot")
        if (loginMenuNotificationDot !== null) {
            loginMenuNotificationDot.classList.add("notification-dot")
        }
    }
}
